module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/static/data-feeds/data-feeds.component.scss
// module id = 618
// module chunks = 0